import { FormProvider } from "react-hook-form";
import {
  ACTUAL_DURATION,
  ACTUAL_END_DATE,
  ACTUAL_START_DATE,
  PERCENTAGE,
  statusOption,
  TASK_STATUS,
} from "./consts";
import { FormDatePicker, FormInput, FormSelect } from "@/components";
import useActualTask from "./useActualTask";

const ActualTask = () => {
  const {
    form,
  } = useActualTask();
  const { errors } = form.formState;

  return (
    <FormProvider {...form}>
      <form>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] pt-[20px] min-h-[400px] overflow-y-scroll px-5 pb-10 no-scrollbar">
          <FormDatePicker
            name={ACTUAL_START_DATE}
            control={form.control}
            label="Actual Start Date"
            placeholder="Please select"
            error={errors[ACTUAL_START_DATE]?.message}
            disabled
          />
          <FormDatePicker
            name={ACTUAL_END_DATE}
            control={form.control}
            label="Actual End Date"
            placeholder="Please select"
            error={errors[ACTUAL_END_DATE]?.message}
            minDate={form.watch(ACTUAL_START_DATE)}
            disabled
          />
          <FormInput
            name={PERCENTAGE}
            control={form.control}
            label="Percentage Completion"
            placeholder="Please enter"
            error={errors[PERCENTAGE]?.message}
            disabled
            maxLength={50}
          />
          <FormSelect
            name={TASK_STATUS}
            control={form.control}
            label="Task Status"
            placeholder="Please select"
            error={errors[TASK_STATUS]?.message}
            options={statusOption}
            disabled
          />
          <FormInput
            name={ACTUAL_DURATION}
            control={form.control}
            label="Actual Duration"
            placeholder="Please enter"
            error={errors[ACTUAL_DURATION]?.message}
            disabled
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default ActualTask;
